import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../components/AuthLayout';
import { LoginForm } from '../components/LoginForm';
import { paths } from 'routes';
import { takeReturnTo } from 'lib/returnTo';

export const Login = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <AuthLayout title={t('website:auth.login.pageTitle')}>
      <LoginForm onSuccess={() => navigate(takeReturnTo() ?? paths.homepage)} />
    </AuthLayout>
  );
};
